import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

// Bump version to reset any previously saved mode (e.g. if it was set to illustrations)
// so the site defaults to realistic photos.
const STORAGE_KEY = "vlimplement:imageMode:v2";

// imageMode: "photos" | "illustrations"
const ImageModeContext = createContext({
  imageMode: "photos",
  setImageMode: () => {},
  toggleImageMode: () => {},
});

export const ImageModeProvider = ({ children }) => {
  const [imageMode, setImageMode] = useState(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored === "photos" || stored === "illustrations") return stored;
    } catch {
      // ignore
    }
    return "photos";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, imageMode);
    } catch {
      // ignore
    }
  }, [imageMode]);

  const value = useMemo(() => {
    return {
      imageMode,
      setImageMode,
      toggleImageMode: () => setImageMode((m) => (m === "photos" ? "illustrations" : "photos")),
    };
  }, [imageMode]);

  return <ImageModeContext.Provider value={value}>{children}</ImageModeContext.Provider>;
};

export const useImageMode = () => useContext(ImageModeContext);

